module.exports = __webpack_public_path__ + "img/logo-sd-pa.12dd1947.png";